import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "8", y1: "5", y2: "7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "7", x2: "7", y1: "19", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "17", x2: "17", y1: "19", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bath";
const Bath = memo(themed(Icon));
export {
  Bath
};
//# sourceMappingURL=bath.js.map
